import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../../reducers'
import { Collection } from './collection'
import {
  sanitizedCollectionsSelector,
  ISanitizedCollections
} from '../../selectors/collections'
import { Container } from '@amzn/dvui/dist/Container'

export interface ICollectionProps {
  collections: ISanitizedCollections
}

const ConnectedCollections = ({ collections }: ICollectionProps) => {
  return (
    <Container>
      {collections.map((col, idx) => {
        if (col === null) return null
        return <Collection {...col} key={`collection-${col.index}-${idx}`} />
      })}
    </Container>
  )
}

const mapStateToProps = (state: IDetailPageState): ICollectionProps => ({
  collections: sanitizedCollectionsSelector(state),
})

export const Collections = connect(mapStateToProps)(ConnectedCollections)
